import React, { useEffect, useState, useMemo } from "react";
import Loader from "../../../../../components/Loader";
import { useTranslation } from "react-i18next";

// ⚠️ N'OUBLIE PAS D'AJOUTER people, filteredPosts ET user DANS LE PARENT ⚠️
export default function TypeDestinationSurvey({ data, people, setDataGraph, setFormattedHeader, filteredPosts, user }) {
    const [destinationSurvey, setDestinationSurvey] = useState();
    const { t, i18n } = useTranslation();

    // 1. RECUPERATION DU FILTRE NOMINATIF
    const normalizedFilteredPosts = useMemo(() => {
        if (Array.isArray(filteredPosts)) {
            const personNames = filteredPosts
                .map(entry => entry.personName?.trim().toLowerCase())
                .filter(Boolean);
            return { personNames };
        }
        return { personNames: [] };
    }, [filteredPosts]);

    useEffect(() => {
        if (data && data.length > 0 && people) {
            handleGraphDestinationSurvey(data);
        }
    }, [data, user, filteredPosts, people]);

    const formatDuration = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = Math.floor(seconds % 60);
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    };

    // ---- UTILITAIRES DE RECHERCHE ET DE VALIDATION ----
    const checkNameMatch = (itemName, person) => {
        if (!itemName) return false;
        const p1 = `${person.firstName || ''} ${person.lastName || ''}`.trim().toLowerCase();
        const p2 = `${person.lastName || ''} ${person.firstName || ''}`.trim().toLowerCase();
        const itemLower = itemName.toLowerCase();

        return itemLower === p1 ||
            itemLower === p2 ||
            itemLower.includes(p1) ||
            itemLower.includes(p2) ||
            p1.includes(itemLower) ||
            p2.includes(itemLower);
    };

    const getPeopleByNumberMap = (peopleFlat) => {
        const map = new Map();
        if(!peopleFlat) return map;
        peopleFlat.forEach(p => {
            [p.phone?.work, p.phone?.mobile].filter(Boolean).forEach(num => {
                if (!map.has(num)) map.set(num, []);
                map.get(num).push(p);
            });
        });
        return map;
    };

    // IDENTIFIE ET FILTRE STRICTEMENT : LOGIQUE SÉPARÉE POUR HOLDING 33 vs AUTRES
    const extractCallEntity = (item, knownNumbers, peopleByNumber, canUseCallerId, personNames) => {
        const isOutgoing = item.direction === "ORIGINATING";
        const isIncoming = item.direction === "TERMINATING";

        if (!isOutgoing && !isIncoming) return null;

        let matchedPost = null;

        // =========================================================
        // LOGIQUE HOLDING 33 : Filtre strict par Nom + Numéro
        // =========================================================
        if (canUseCallerId) {
            if (isOutgoing) {
                const workOrMobile = item.callingnumber;
                if (knownNumbers.has(workOrMobile)) {
                    matchedPost = item.calleridnumber ? item.calleridnumber : workOrMobile;

                    const itemName = (item.callinglineid || "").trim();
                    const persons = peopleByNumber.get(workOrMobile) || [];

                    let matchedName = "";
                    if (itemName) {
                        const bestMatch = persons.find(p => checkNameMatch(itemName, p));
                        matchedName = bestMatch ? `${bestMatch.firstName} ${bestMatch.lastName}` : itemName;
                    } else {
                        matchedName = persons.length > 0 ? `${persons[0].firstName} ${persons[0].lastName}` : "";
                    }

                    if (personNames && personNames.length > 0) {
                        const nameToVerify = itemName ? itemName.toLowerCase() : matchedName.toLowerCase();
                        const isRequestedPerson = personNames.some(filterName =>
                            nameToVerify.includes(filterName) || filterName.includes(nameToVerify)
                        );
                        if (!isRequestedPerson) return null; // Détruit l'appel !
                    }
                }
            } else if (isIncoming) {
                const calledNum = item.callednumber;
                if (knownNumbers.has(calledNum)) {
                    matchedPost = calledNum;
                    const persons = peopleByNumber.get(calledNum) || [];

                    const itemName = (item.calledlineid || "").trim();
                    let matchedName = "";
                    if (itemName) {
                        const bestMatch = persons.find(p => checkNameMatch(itemName, p));
                        matchedName = bestMatch ? `${bestMatch.firstName} ${bestMatch.lastName}` : itemName;
                    } else {
                        matchedName = persons.length > 0 ? `${persons[0].firstName} ${persons[0].lastName}` : "";
                    }

                    if (personNames && personNames.length > 0) {
                        const nameToVerify = itemName ? itemName.toLowerCase() : matchedName.toLowerCase();
                        const isRequestedPerson = personNames.some(filterName =>
                            nameToVerify.includes(filterName) || filterName.includes(nameToVerify)
                        );
                        if (!isRequestedPerson) return null; // Détruit l'appel !
                    }
                }
            }
        }
        // =========================================================
        // LOGIQUE STANDARD : Les autres Holdings (Fonctionnement classique)
        // =========================================================
        else {
            if (isOutgoing && knownNumbers.has(item.callingnumber)) {
                matchedPost = item.callingnumber;
            } else if (isIncoming && knownNumbers.has(item.callednumber)) {
                matchedPost = item.callednumber;
            }
        }

        return matchedPost; 
    };

    const handleGraphDestinationSurvey = (data) => {
        const canUseCallerId = user && user.holdingId === 33;
        const personNames = normalizedFilteredPosts.personNames;
        
        const peopleFlat = people ? people.flat() : [];
        const peopleByNumber = getPeopleByNumberMap(peopleFlat);
        const knownNumbers = new Set(peopleByNumber.keys());

        let destinations = {};

        data.forEach(item => {
            // 🛡️ APPLICATION DU BOUCLIER 🛡️
            if (canUseCallerId) {
                 const entity = extractCallEntity(item, knownNumbers, peopleByNumber, canUseCallerId, personNames);
                 if (!entity && personNames.length > 0) return; // Ignore l'appel si rejeté
            }

            const calltype = item.calltype;
            if (!destinations[calltype]) {
                destinations[calltype] = {
                    Outgoing: {
                        total: 0,
                        durationTotal: 0,
                        averageduration: 0,
                        response: 0,
                        averageresponse: 0,
                        noresponse: 0
                    },
                    Incoming: {
                        total: 0,
                        durationTotal: 0,
                        averageduration: 0,
                        response: 0,
                        averageresponse: 0,
                        noresponse: 0
                    }
                };
            }
            if (item.direction === "TERMINATING") {
                destinations[calltype].Incoming.total += 1;
                destinations[calltype].Incoming.durationTotal += Math.floor(parseInt(item.duration) || 0);
                if (item.answerindicator === "Yes") {
                    destinations[calltype].Incoming.response += 1;
                    destinations[calltype].Incoming.averageresponse += Math.floor(parseInt(item.ringduration) || 0);
                } else if (item.answerindicator === "No") {
                    destinations[calltype].Incoming.noresponse += 1;
                }
            } else if (item.direction === "ORIGINATING") {
                destinations[calltype].Outgoing.total += 1;
                destinations[calltype].Outgoing.durationTotal += Math.floor(parseInt(item.duration) || 0);
                if (item.answerindicator === "Yes") {
                    destinations[calltype].Outgoing.response += 1;
                    destinations[calltype].Outgoing.averageresponse += Math.floor(parseInt(item.ringduration) || 0);
                } else if (item.answerindicator === "No") {
                    destinations[calltype].Outgoing.noresponse += 1;
                }
            }
        });

        for (let calltype in destinations) {
            let Outgoing = destinations[calltype].Outgoing;
            let Incoming = destinations[calltype].Incoming;

            Outgoing.averageduration = Outgoing.total > 0 ? Outgoing.durationTotal / Outgoing.total : 0;
            Outgoing.averageresponse = Outgoing.response > 0 ? Outgoing.averageresponse / Outgoing.response : 0;

            Incoming.averageduration = Incoming.total > 0 ? Incoming.durationTotal / Incoming.total : 0;
            Incoming.averageresponse = Incoming.response > 0 ? Incoming.averageresponse / Incoming.response : 0;

            Outgoing.durationTotal = formatDuration(Outgoing.durationTotal);
            Outgoing.averageduration = formatDuration(Outgoing.averageduration);
            Outgoing.averageresponse = formatDuration(Outgoing.averageresponse);

            Incoming.durationTotal = formatDuration(Incoming.durationTotal);
            Incoming.averageduration = formatDuration(Incoming.averageduration);
            Incoming.averageresponse = formatDuration(Incoming.averageresponse);
        }
        setDestinationSurvey(destinations);
        const formattedData = formatForExcel(destinations);
        setDataGraph(formattedData);

    }
    const formatForExcel = (data) => {
        // En-têtes des colonnes
        const headers = ["", "Sortants", "Entrants"];

        const keysMapping = [
            { key: "response", label: "Nombre d'appels répondu" },
            { key: "averageresponse", label: "Durée moyenne pour répondre" },
            { key: "noresponse", label: "Nombre d'appels non répondu" },
            { key: "durationTotal", label: "Durée totale d'appels" },
            { key: "averageduration", label: "Durée moyenne d'appels" },
        ];

        // Format des données pour Excel : première ligne = headers
        const excelData = [headers];
    
        // Parcourir chaque zone (Courbevoie, Lyon, etc.)
        Object.keys(data).forEach(origine => {
            // Ajouter une ligne pour la zone
            excelData.push([`Origine: ${getCallType(origine)}`, "", ""]);

            // Parcourir chaque clé et créer les lignes associées
            keysMapping.forEach(({ key, label }) => {
                const row = [
                    label,  // Utiliser la traduction pour le label
                    data[origine].Outgoing[key] !== undefined ? data[origine].Outgoing[key] : null,  // Valeur pour Sortants
                    data[origine].Incoming[key] !== undefined ? data[origine].Incoming[key] : null   // Valeur pour Entrants
                ];
                excelData.push(row);  // Ajouter la ligne à excelData
            });
        });

        setFormattedHeader(true);

        return excelData;
    };

    const getCallType = (callType) => {
        switch (callType) {
            case 'SIP_ENTERPRISE': return 'Interne';
            case 'SIP_NATIONAL': return 'National';
            case 'SIP_MOBILE': return 'Mobile';
            case 'SIP_INTERNATIONAL': return 'International';
            case 'SIP_PREMIUM': return 'Premium';
            case 'SIP_INBOUND': return 'Entrant';
            case 'SIP_OPERATOR': return 'Opérateur';
            case 'SIP_TOLLFREE': return 'Sans frais';
            case 'SIP_MEETING': return 'Réunion';
            case 'UNKNOWN': return 'Inconnu';
            default: return callType;
        }
    }

    if (destinationSurvey && Object.keys(destinationSurvey).length === 0) {
        return (
            <div>{t("Aucune donnée disponible")}</div>
        );
    }
    
    return (
        <div className="destinationSurvey">
            {destinationSurvey ? (
                <div>
                    <table className="destinationSurvey-sortants">
                        <thead>
                            <tr className="sortant"><th colSpan={6}>{t("Sortants")}</th></tr>
                            <tr className="sortant-head">
                                <th title={t("Origine")}>{t("Origine")}</th>
                                <th title={t("Nombre d'appels répondu")}>{t("Nombre d'appels répondu")}</th>
                                <th title={t("Durée moyenne pour répondre")}>{t("Durée moyenne pour répondre")}</th>
                                <th title={t("Nombre d'appels non répondu")}>{t("Nombre d'appels non répondu")}</th>
                                <th title={t("Durée totale d'appels")}>{t("Durée totale d'appels")}</th>
                                <th title={t("Durée moyenne d'appels")}>{t("Durée moyenne d'appels")}</th>
                            </tr>
                        </thead>
                        <tbody>
                        {Object.keys(destinationSurvey).map((calltype, index) => (
                            <tr className="sortant-body" key={index}>
                                <td>{getCallType(calltype)}</td>
                                <td>{destinationSurvey[calltype].Outgoing.response}</td>
                                <td>{destinationSurvey[calltype].Outgoing.averageresponse}</td>
                                <td>{destinationSurvey[calltype].Outgoing.noresponse}</td>
                                <td>{destinationSurvey[calltype].Outgoing.durationTotal}</td>
                                <td>{destinationSurvey[calltype].Outgoing.averageduration}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <table className="destinationSurvey-entrants">
                        <thead>
                            <tr className="entrant"><th colSpan={6}>{t("Entrants")}</th></tr>
                            <tr>
                                <th title={t("Nombre d'appels répondu")}>{t("Nombre d'appels répondu")}</th>
                                <th title={t("Durée moyenne pour répondre")}>{t("Durée moyenne pour répondre")}</th>
                                <th title={t("Nombre d'appels non répondu")}>{t("Nombre d'appels non répondu")}</th>
                                <th title={t("Durée totale d'appels")}>{t("Durée totale d'appels")}</th>
                                <th title={t("Durée moyenne d'appels")}>{t("Durée moyenne d'appels")}</th>
                            </tr>
                        </thead>
                        <tbody>
                        {Object.keys(destinationSurvey).map((calltype, index) => (
                            <tr key={index}>                            
                                <td>{destinationSurvey[calltype].Incoming.response}</td>
                                <td>{destinationSurvey[calltype].Incoming.averageresponse}</td>
                                <td>{destinationSurvey[calltype].Incoming.noresponse}</td>
                                <td>{destinationSurvey[calltype].Incoming.durationTotal}</td>                            
                                <td>{destinationSurvey[calltype].Incoming.averageduration}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <Loader/>
            )}
        </div>
    );
}